import {
  CHECK_EMAIL,
  LOGIN,
  SIGNUP,
  INITIATE_PASSWORD_RESET,
  UPDATE_USER,
  CHANGE_PASSWORD
} from '../graphql/queries/UserQueries'
import { apolloClient } from '../graphql/apollo'

export const checkEmail = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: CHECK_EMAIL,
      variables: { input }
    })
    return data.checkEmail
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const signup = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: SIGNUP,
      variables: { input }
    })
    return data.signup
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const login = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: LOGIN,
      variables: { input }
    })
    return data.login
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const initiatePasswordReset = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: INITIATE_PASSWORD_RESET,
      variables: { input }
    })
    return data.initiatePasswordReset
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const updateUser = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: UPDATE_USER,
      variables: { input }
    })
    return data.updateUser
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const changePassword = async input => {
  try {
    const { data } = await apolloClient.mutate({
      mutation: CHANGE_PASSWORD,
      variables: { input }
    })
    return data.changePassword
  } catch (e) {
    console.log(e)
    throw e
  }
}
